import token from '@/storage/token.js'
import api from '@/api/index'

export default {
  namespaced: true,
  getters: {
    selected_article (state, getters, rootState, rootGetters) {
      return state.selected_article
    },
  },
  state: {
    selected_article: {},
  },
  mutations: {
    update_selected_article (state, payload) {
      console.log('mutation_selected_article: state=', state, ', payload=', payload)
      if(payload.action === 'delete') {
        delete state.selected_article[payload.id]
      }else if(payload.action === 'add') {
        state.selected_article[payload.id] = payload.system_id
      }
    },
    clear_select_article(state) {
      state.selected_article = {}
    },
  },
  actions: {}
}